import React from "react";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Button,
    CircularProgress, Grid, IconButton,
    Tooltip,
    Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {getAddresse, getDataInString} from "../RightAccordion";
import IconesRight from "../../pages/compos/IconesRight";
import InfoIcon from "@mui/icons-material/Info";
import IconMaison from "../../ico/IconMagasin";
import LocalParkingIcon from "@mui/icons-material/LocalParking";
import AspectRatioIcon from "@mui/icons-material/AspectRatio";
import HeightIcon from "@mui/icons-material/Height";
import IconEtage2 from "../../ico/IconEtage2";
import IconMSquare2 from "../../ico/IconMSquare2";
import IconMur from "../../ico/IconMur";
import IconToit from "../../ico/IconToit";
import {resBdnb} from "../AttributBdnb";
import FlatBar3 from "../FaltBar3";
import {getDpeColor, getMaxDpeValue} from "../../pages/dpeByIris/MapPage";
import {mergeValuesAndLabels, resDpeV2} from "../AttributDpeV2";
import FlatDpe from "../FaltDpe";
import {resDpeV1} from "../AttributDpeV1";


export default function DpeV1Details({selectedItem}) {
    const [open, setOpen] = React.useState(true);

    return (<Box sx={{
            width: "90%",
            borderRadius: "8px",
            backgroundColor: "#f7f9fc",
            padding: 2
        }}>
            <Box sx={{
                display: "flex",
                width: "100%",
                borderColor: "#000",
                borderBottomStyle: "solid",
                height: 30
            }}>
                <Typography>CLASSE DPE</Typography>
            </Box>
            <Box sx={{
                display: "flex",
                width: "100%",
                flexDirection: "column",
            }}
            >
                <Box sx={{
                    display: "flex",
                    width: "100%",
                    flexDirection: "column",
                }}>
                    <Box sx={{
                        display: "flex",
                        width: "100%",
                        flexDirection: "column",
                    }}>
                        <Box sx={{
                            display: "flex",
                            borderBottomStyle: "dashed",
                            borderColor: "#505050",
                            borderWidth: "thin",
                            marginTop: 2,
                            marginBottom: 2,
                            alignItems: "center",
                            justifyContent: "flex-start",

                            width: "100%"
                        }}>
                            <Box sx={{width: "60%"}}>
                                <Typography sx={{fontWeight: 300}} variant="body2" display="block"
                                            gutterBottom>Catégorie DPE opposables retenue :
                                </Typography>
                            </Box>
                            <Box sx={{width: "40%"}}>
                                <Box width={{
                                    width: 40,
                                    height: 20,
                                    backgroundColor: getDpeColor(getMaxDpeValue(selectedItem.listOfDpeV1,"classe_conso_energie_arrete_2012")),
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    borderRadius: 5
                                }}>
                                    <Typography sx={{fontWeight: 500}} color={"#000"} variant="body2">
                                        {getMaxDpeValue(selectedItem.listOfDpeV1,"classe_conso_energie_arrete_2012")}
                                    </Typography>
                                </Box>
                            </Box>
                        </Box>

                    </Box>
                    <Box sx={{
                        display: "flex",
                        borderColor: "#505050",
                        marginTop: 1,
                        marginBottom: 1,
                        alignItems: "center",
                        justifyContent: "flex-start"
                    }}>
                        <Box sx={{width: "60%"}}>
                            <Typography sx={{fontWeight: 300}} variant="body2" display="block"
                                        gutterBottom>{selectedItem.listOfDpeV1.length} DPE réalisés
                            </Typography>
                        </Box>
                        <Box sx={{width: "40%"}}>
                        </Box>
                    </Box>
                    <FlatDpe
                        values={selectedItem.listOfDpeV1}
                        labels={["G", "F", "E", "D", "C", "B", "A"]}
                        colors={["#f71e1a", "#f79b40", "#f6c824", "#f7f72b", "#cefc43", "#43ce3f", "#2d682e"]}
                        classe={"dpe"}
                    />

                </Box>

                <Box sx={{
                    display: "flex",
                    borderColor: "#505050",
                    marginTop: 1,
                    marginBottom: 1,
                    alignItems: "center",
                    justifyContent: "flex-start"
                }}>
                    <Box sx={{width: "60%"}}>
                        <Typography sx={{fontWeight: 300}} variant="body2" display="block"
                                    gutterBottom>Classe GES
                        </Typography>
                    </Box>
                    <Box sx={{width: "40%"}}>
                    </Box>
                </Box>
                <FlatDpe
                    values={resDpeV1.dpes}
                    labels={["G", "F", "E", "D", "C", "B", "A"]}
                    colors={["#9d13e9", "#b850f4", "#c875f7", "#d697f9",
                        "#deabfa", "#e8c4fc", "#f8eefe"]}
                    classe={"ges"}/>


            </Box>
        </Box>
    )
}

